const baseUrl = '/clients';
const clientsUrl = {
  baseUrl,
  create: `${baseUrl}/create`,
  edit: `${baseUrl}/edit`,
};

export default clientsUrl;
